export default () => ({
  componentName: 'cell-price-modifications',
});
